module.exports = __webpack_public_path__ + "static/media/saffron2.855b2d5d.jpg";